// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"1":"3e285db1","331":"5152b5de","739":"ea3bc05b","964":"6ea789d7","980":"aa30c857"}[chunkId] + ".chunk.js";
};